(function() {
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  function roundUp5(x) {
      return Math.ceil(x/5)*5;
  }

  function roundDown5(x) {
      return Math.floor(x/5)*5;
  }

  var today = Date.today();//.set({ day: 1 });
  var lastDayOfMonth = Date.today().moveToLastDayOfMonth();

  var lastDay = roundUp5(today.getDate());
  //daca nextDay este 30 ale lunii si luna are 31 de zile, fortam sa fie 31
  if (lastDay - lastDayOfMonth.getDate() == -1 || lastDay > lastDayOfMonth.getDate()) {
      lastDay = lastDayOfMonth.getDate();
  }

  var firstDay = roundDown5(lastDay - 5);
  if (firstDay <= 0) {
      firstDay = 1;
  }

  var announcement      = $('.announcement-bar__message').first();
  var announcement_text = announcement.html();
  var current_month     = capitalizeFirstLetter(today.toString("MMMM"));
  announcement_text = announcement_text.replace('[first-day]', firstDay);
  announcement_text = announcement_text.replace('[last-day]', lastDay + ' ' + current_month);
  announcement.html(announcement_text);
})();